import { SiteControllerType } from "@/lib/gql/__generated__/graphql";

import { externalLink } from "@/routes/_constants/external-link";

/** サイトコントローラーごとのプラン連携マニュアルURL。連携先が増え次第、都度追加する */
const SC_PLAN_SYNC_MANUAL_URL: Partial<Record<SiteControllerType, string>> = {
	[SiteControllerType.Neppan]: `${externalLink.faqSite}/faq/host/site-controller/3c9fffe15c57811294cdc9a1bdb9013e`,
	// 手間いらずの接続マニュアル（プラン連携は2026年9月23日以降の運用）
	[SiteControllerType.Temairazu]: `${externalLink.faqSite}/faq/host/site-controller/3d8fffe15c578017a8d6c5cbcf82d6f7`,
};

export const getScPlanSyncManualUrl = (siteControllerType: SiteControllerType): string | undefined =>
	SC_PLAN_SYNC_MANUAL_URL[siteControllerType];
